module.exports = __webpack_public_path__ + "img/OBJECTS-1.f96c9d66.png";